import React from 'react';
import { Button } from './ui/button';
import { DownloadSimple } from '@phosphor-icons/react';
import { downloadCsv, todayStamp } from '../lib/exportCsv';
import { toast } from 'sonner';

/**
 * Reusable CSV export button.
 * Props:
 *  - rows: array of objects to export
 *  - columns: [{ key, label, format? }]
 *  - filename: base name (stamp is appended)
 *  - label: optional button label override
 *  - variant/size/className: style passthrough
 *  - disabled: overrides "no data" check
 *  - testId: data-testid for the button
 */
export default function ExportButton({
  rows = [],
  columns = [],
  filename = 'export',
  label = 'Export CSV',
  variant = 'outline',
  size,
  className = '',
  testId = 'export-csv-btn',
  disabled,
}) {
  const isEmpty = !rows || rows.length === 0 || !columns || columns.length === 0;

  const handleClick = () => {
    if (isEmpty) {
      toast.error('No data to export');
      return;
    }
    try {
      downloadCsv(rows, columns, `${filename}_${todayStamp()}.csv`);
      toast.success(`Exported ${rows.length} ${rows.length === 1 ? 'row' : 'rows'}`);
    } catch (e) {
      toast.error('Export failed');
    }
  };

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={handleClick}
      data-testid={testId}
      disabled={disabled}
      className={`rounded-none gap-2 ${className}`}
      title={isEmpty ? 'No data to export' : `Export ${rows.length} rows`}
    >
      <DownloadSimple size={14} weight="bold" />
      {label}
    </Button>
  );
}
